const initialState = {
    token:'',
    refreshToken: '',
    tokenExpiresIn: '',
    refreshTokenExpiresIn: ''
};

const LeaderPortalReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'SET_LEADER_TOKEN':
            return {
                ...state,
                token: action.payload.token,
                refreshToken: action.payload.refreshToken,
                tokenExpiresIn: action.payload.tokenExpiresIn,
                refreshTokenExpiresIn: action.payload.refreshTokenExpiresIn,
            };
        case 'RESET' :
            return initialState;
        default:
            return state;
    }
};

export default LeaderPortalReducer;